<template>
  <div class='SelectCateg'>
    <div class="cont-categ">
      <div class="header">{{ Empresa.modelo === 'Modelo 03' ? 'Categorias das captações' : 'Categorias' }}</div>
      <div class="cont">
        <input-categ
        v-for="(categ, key) in Categorias.filter(c  => c.name !== '')"
        :key="key"
        :data="categ"
        :categProd="JSON.parse(SelectedProdEdit.categoria)"
        @edit:catecogia="ShowAddCateg=true"
        />
      </div>
      {{ Categoria }}
    </div>
    <div>
      <div class="btn" @click="ShowAddCateg=!ShowAddCateg">
      +Adicionar nova Categoria
      </div>
      <div v-if="ShowAddCateg">
        <input-icon-categ
        @click="SetModal({ component: 'SelectIcon', active: true, callback: 'SetIcon' })"
        />
        <input-reg
        :value="SelectedCategEdit.name"
        @update:model-value="newValue => changeCategEdit({ name: newValue })"
        text="Nome da Categoria"
        :label="{ marginLeft: '5px', textAlign: 'left', marginTop: '5px' }"
        :input="{ width: '95%', border: 'thin solid #CCCCCC', borderRadius: '5px', padding: '2%', fontSize: '16px' }"
        />
        <div>
          <button
          @click="handleCateg"
          >
            Salvar categoria
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import InputCateg from './InputCateg'
import InputReg from './InputReg'
// import InputSelect from './InputSelect'
import InputIconCateg from './InputIconCateg'
export default {
  name: 'SelectCateg',
  components: { InputCateg, InputReg, InputIconCateg },
  data () {
    return {
      ShowAddCateg: false,
      parent: '',
      name: ''
    }
  },
  computed: {
    ...mapGetters(['Categorias', 'SelectedProdEdit', 'SelectedCategEdit', 'Empresa'])
  },
  methods: {
    ...mapActions(['PushCateg', 'SetModal', 'GetCategory', 'changeCategEdit', '_UpdateCategory']),
    handleCateg () {
      if(this.SelectedCategEdit.id !== '') {
        this._UpdateCategory(this.SelectedCategEdit)
          .then(() => this.GetCategory())
          .then(() => this.changeCategEdit({ id: '', name: '', icon: '', active: false }))
      } else {
        this.PushCateg({
          active: false,
          name: this.SelectedCategEdit.name,
          icon: this.SelectedCategEdit.icon 
        })
        .then(() => {
          this.changeCategEdit({ id: '', name: '', icon: '', active: false })
        })
      }
    }
  },
  created () {
    this.GetCategory()
  }
}
</script>

<style scoped>
.SelectCateg {
  width: 90%;
  margin: auto;
  border-radius: 5px;
  margin-top: 6%;
}

.cont-categ {
  height: 220px;
  border: thin solid #CCCCCC;
  border-radius: 5px;
}

.header {
  width: 100%;
  height: 18%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: thin solid #CCCCCC;
}

.cont {
  height: 79%;
  padding: 1%;
  overflow: auto;
}

.btn {
  width: 100%;
  height: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: underline;
  font-size: 14px;
  cursor: pointer;
}

button {
  border: 0;
  padding: 3%;
  font-size: 12px;
  margin-top: 10px;
  border-radius: 2px;
  background-color: #CCCCCC;
  cursor: pointer;
}
</style>
